import React, { useState } from 'react'
import { FiglioCard } from 'components/molecules'
import { FormBambino } from 'components/organisms'
import styles from './MyAccountFiglioFormCard.module.sass'

interface Props {
  onDeleteFiglio: (id: number) => void
  dati?: {
    firstName: string
    genderType: 'f' | 'm' | 'x'
    dataNascita: string
    pk?: number
    isTwin: boolean
  }
  refetch: any
}

const MyAccountFiglioFormCard = (props: Props) => {
  const { dati = null, onDeleteFiglio, refetch } = props
  const [edit, setEdit] = useState(false)

  return (
    <div className={styles.myAccountFiglioFormCard}>
      {edit ? (
        <div className={styles.editForm}>
          <FormBambino
            initialValuesFromProps={dati}
            refetchInitialValues={refetch}
            isEdit
            onClose={() => setEdit(false)}
          />
        </div>
      ) : (
        <FiglioCard
          dati={dati}
          isFiglioProfile
          onEdit={() => setEdit(true)}
          onDeleteFiglio={onDeleteFiglio}
        />
      )}
    </div>
  )
}

export default MyAccountFiglioFormCard
